import { Text } from 'ui-kit/typography'
import { DifferenceHeroDataType } from './differenceHeroData'
import classes from './DifferenceHero.module.scss'

export const DifferenceHeroCard = ({
  item,
}: {
  item: DifferenceHeroDataType
}) => {
  const { title, caption, image1x, image2x } = item

  return (
    <li className={classes.item}>
      <Text lh={'tight'} balance center className={classes.caption}>
        {title}
      </Text>
      <picture className={classes.image}>
        <source media='(min-resolution: 2dppx)' srcSet={image2x.src} />
        <source media='(min-width: 576px)' srcSet={image2x.src} />
        <img
          src={image1x.src}
          alt={caption}
          fetchPriority={'high'}
          loading={'eager'}
        />
      </picture>
    </li>
  )
}
